<template>
    <v-container bg fill-height grid-list-md text-xs-center>
        <LoadingComponent :loading="loading" :message="loadingMessage" style="z-index: 1000;"></LoadingComponent>

        <v-layout row wrap align-center>
            <v-card class="mx-auto" width="50%" rounded elevation="3" v-show="!loading">
                <v-card-title>
                    <div class="headline" style="color: #4a4a4a">{{ $t('passwordRecovery.recoveryCode') }}</div>
                </v-card-title>

                <v-card-text v-if="!erro">
                    <v-container>
                        <v-row>
                            <v-text-field
                                v-model="codigoDigitado"
                                solo
                                class="code__input"
                                @change="formatCodigo"
                            ></v-text-field>
                        </v-row>
                        <v-row justify="end" style="margin: 0;">
                            <v-btn text @click="validarCodigo" x-small :disabled="isCodigoOk">{{ $t('passwordRecovery.validate') }}</v-btn>
                        </v-row>
                    </v-container> 
                    <v-container v-if="isCodigoOk">
                        <v-form ref="form" v-model="formValidado">
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field
                                    v-model="senha"
                                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="show1 ? 'text' : 'password'"
                                    :label="$t('passwordRecovery.newPassword')"
                                    :rules="[validaSenha]"
                                    @click:append="show1 = !show1"
                                    ></v-text-field>
                                </v-col>
                                </v-row>
                                <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field
                                    v-model="repetirsenha"
                                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="show2 ? 'text' : 'password'"
                                    :label="$t('passwordRecovery.repeatPassword')"
                                    :rules="[validaRepeticaoSenha]"
                                    @click:append="show2 = !show2"
                                    ></v-text-field>
                                </v-col>
                                </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>

                <v-card-text v-else>
                    <div>{{ $t('passwordRecovery.invalidOrExpiredRequest') }}</div>
                </v-card-text>

                <v-card-actions v-if="isCodigoOk">
                    <v-spacer></v-spacer>
                    <v-btn dark style="margin: 10px;" @click="alterarSenha" v-if="!senhaAlterada">{{ $t('button.send') }}</v-btn>
                    <v-btn dark style="margin: 10px;" @click="() => this.$router.push('/')" v-else>{{ $t('passwordRecovery.goToLogin') }}</v-btn>
                </v-card-actions>

                </v-card>
        </v-layout>
        <v-card></v-card>
    </v-container>
</template>
<script>
import apiController from '@/utils/apiController';
import LoadingComponent from './LoadingComponent.vue';
import EventBus from "@/utils/eventBus";

export default {
    components: {
        LoadingComponent,
    },
    data: () => ({
        id: null, 
        token: null, 
        loading: false,
        codigo: null,
        codigoDigitado: null, 
        erro: true,
        formValidado: false,
        isCodigoOk: false,
        senha: null, 
        repetirsenha: null, 
        show1: false, 
        show2: false,
        senhaAlterada: false,
    }),
    computed: {
        loadingMessage() {
            return this.$t('system.messages.loading');
        },
    },
    created() {
        this.initialize();
    },
    methods: {
        initialize() {
            this.loading = true;
            this.token = this.$route.query.q;

            apiController.request(apiController.endpoints.verificarecuperacaosenha, {
                data: { token: this.token },
                silent: true,
                onSuccess: (response) => {
                    this.loading = false;
                    this.erro = response.data.erro;
                    if (!response.data.erro) {
                        this.codigo = response.data.user.codigo;
                        this.id = response.data.user.id;
                    }
                    console.log(response.data);
                },
                onError: (e) => {
                    this.loading = false;
                    this.erro = true;
                    this.codigo = null;
                    this.id = null;
                    console.log(e);
                },
            })
        },
        formatCodigo() {
            if (this.codigoDigitado.length > 0) {
                this.codigoDigitado = this.codigoDigitado.toUpperCase();
            }
        },
        validarCodigo() {
            this.isCodigoOk = this.codigo === this.codigoDigitado;
            if (!this.isCodigoOk) {
                EventBus.$emit('show-alert', {
                    mensagem: this.$t('passwordRecovery.invalidCode'),
                    tipo: 'error'
                });
            }
        },
        validaSenha() {
            if (this.senha == null) {
                return this.$t('passwordRecovery.passwordRequired');
            } else {
                if (this.senha.length === 0) {
                return this.$t('passwordRecovery.passwordRequired');
                } else {
                if (
                    !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#])[0-9a-zA-Z$*&@#]{12,}$/.test(
                    this.senha
                    )
                ) {
                    return this.$t('passwordRecovery.passwordValidation');
                } else {
                    return true;
                }
                }
            }
        },
        validaRepeticaoSenha() {
            if (
                this.repetirsenha == null ||
                this.repetirsenha == "" ||
                this.repetirsenha.length < 1
            ) {
                return this.$t('passwordRecovery.passwordRequired');
            } else {
                if (this.senha != this.repetirsenha) {
                return this.$t('passwordRecovery.passwordsMustMatch');
                } else {
                return true;
                }
            }
        },
        alterarSenha() {
            this.$refs.form.validate();
            if (this.formValidado) {
                var registro = {
                    id_usuario: this.id,
                    senha: this.senha,
                    repetirsenha: this.repetirsenha,
                };
                apiController.request(apiController.endpoints.alteraSenha, {
                    data: registro,
                    config: { headers: { "x-access-token": this.token } },
                    onSuccess: (response) => {
                        if (response.data.erro) {
                            this.mensagemAlerta = this.$t('passwordRecovery.passwordChangeError');
                            this.tipoAlerta = "error";
                            this.showAlert = true;
                        } else {
                            this.resetRecuperacao();
                        }
                    },
                });
            }
        },
        resetRecuperacao() {
            apiController.request(apiController.endpoints.resetrecuperacao, {
                data: { id: this.id },
                config: { headers: { "x-access-token": this.token } },
                onSuccess: (response) => {
                    EventBus.$emit('show-alert', {
                        mensagem: response.data.erro ? this.$t('passwordRecovery.passwordChangeError') : this.$t('passwordRecovery.passwordChangedSuccess'),
                        tipo: response.data.erro ? 'error' : 'success'
                    });
                    if (!response.data.erro) {
                        this.senhaAlterada = true;
                    }
                },
            });
        }
    }
}
</script>

<style scoped>
.code__input >>> input {
    text-align: center;
}
</style>